import React from 'react';
import { Button } from '@src/stories/elements/Button/Button';
import { SuccessStoryCard } from '../Components/SuccessStoryCard';

export default function Grid({ settings, section, blocks }) {
  const { successStories } = settings;
  const columnCount = section.columns_count || 3;

  return (
    <div className="flex flex-col gap-[52px]">
      <div className="flex gap-4 items-center justify-between">
        {section.title && (
          <div className={`${section.title_font_type}`}>
            {section.title}
          </div>
        )}

        {section.view_all_text && section.view_all_url && (
          <a href={section.view_all_url} className="link link-primary cursor-pointer py-3 px-6">
            <span className="button__label">{section.view_all_text}</span>
            <span className={`icon-${section.view_all_icon || 'right-arrow-alt'} button__icon no-underline`}></span>
          </a>
        )}
      </div>
      <div className={`flex-1 grid grid-cols-${columnCount} gap-x-[${section.gap}px] gap-y-[${section.gap_vertical}px]`}>
        {successStories.map((column, index) => {
          const block = blocks.find(b => b.id === column.block_id);
          return <SuccessStoryCard key={index} column={column} block={block} />;
        })}
      </div>
    </div>
  );
}